import { NgModule ,  CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DynamicFormComponent } from './core/dynamic-form/dynamic-form.component';
import { Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from './modules/material.module';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorMessageComponent } from './core/error-message/error-message.component';
import { InputControlComponent } from './core/input-control/input-control.component';
import { InputControlReadOnlyComponent } from './core/input-control-read-only/input-control-read-only.component';
import { PasswordToggleControlComponent } from './core/password-toggle/password-toggle.component';
import { DatepickerComponent } from './core/datepicker/datepicker.component';
import { TimepickerComponent } from './core/timepicker/timepicker.component';
import { DropdownComponent } from './core/dropdown/dropdown.component';
import { RadioComponent } from './core/radio/radio.component';
import { CheckboxComponent } from './core/checkbox/checkbox.component';
import { ArrayTransformPipe } from './utilities/pipes/array-transform.pipe';
import { LinkifyPipe } from './utilities/pipes/linkify.pipe';
import { NgbDatePickerComponent } from './core/ngb-datepicker/ngb-datepicker.component';
import { SearchableDropdownComponent } from './core/searchable-dropdown/searchable-dropdown.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DynamicControlComponent } from './core/dynamic-control/dynamic-control.component';
import { HorizontalRuleComponent } from './core/horizontal-rule/horizontal-rule.component';
import { CommonModule } from '@angular/common';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CoreDependencyInjectorService } from './utilities/services/dependency-injector.service';
import { CoreComponent } from './components/base-form/base-form.component';
import { ModuleWithProviders } from '@angular/core';


const modules = [CommonModule, MaterialModule, NgxFileDropModule, NgxMaterialTimepickerModule,
  NgxExtendedPdfViewerModule];
const declaration = [DynamicControlComponent, DynamicFormComponent, CoreComponent,
  ErrorMessageComponent, InputControlComponent, InputControlReadOnlyComponent, PasswordToggleControlComponent,
  DatepickerComponent, TimepickerComponent, DropdownComponent, RadioComponent, CheckboxComponent, ArrayTransformPipe,
  LinkifyPipe, NgbDatePickerComponent, SearchableDropdownComponent, HorizontalRuleComponent];

@NgModule({
  declarations: [...declaration],
  imports: [
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    MaterialModule,
    ...modules
  ],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDatePickerComponent }
  ],
  exports: [...modules, ...declaration],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class EvisaDynamicFormModule {
  constructor(injector: Injector) {
    CoreDependencyInjectorService.setInjector(injector); }

  /**
   * // @param environment
   */
  public static forRoot(environment: any): ModuleWithProviders {

    return {
      ngModule: EvisaDynamicFormModule,
      providers: [
        {
          provide: 'ENV_CONFIG',
          useValue: environment
        }
      ]
    };
  }

}
